module.exports = __webpack_public_path__ + "img/m_icon1.e2241b15.png";